(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-floorball/assets/javascripts/league.js') >= 0) return;  svs.modules.push('/components/themes/sport-floorball/assets/javascripts/league.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_floorball = svs.themes.sport_floorball || {};

  svs.themes.sport_floorball.formatTable = function(league) {
    _.each(league, function(team) {
      if (_.isObject(team)) {
        team.position = parseInt(team.position, 10);
      }
    });
    return league;
  };

  svs.themes.sport_floorball.getFormationByPosition = function() {
    return {};
  };

  svs.themes.sport_floorball.isShowHomeAwayTables = function() {
    return true;
  };
})(svs);

 })(window);